import { render, staticRenderFns } from "./MyCamera.vue?vue&type=template&id=4b05834b&"
import script from "./MyCamera.vue?vue&type=script&lang=js&"
export * from "./MyCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports